import React from 'react';
import { Tabs } from 'antd';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import {
  BikerBedIconSearch,
  MemberSearchIcon,
  BikerClubIconSearch,
  ToursIconSearch,
  PlacesSearchIcon,
  AboutSearchIcon,
} from '../MainMenu/svg';

import {
  setFilterScope,
  setRoadTypesFilter,
} from '../../../actions/Search/search.action';

import { TourTypesFilter } from './tourTypesFilter';
import {
  SEARCH_BAR_ALL,
  SEARCH_BAR_MEMBER,
  SEARCH_BAR_PLACES,
  SEARCH_BAR_BIKER_BED,
  SEARCH_BAR_BIKE_CLUB,
  SEARCH_BAR_TOUR,
} from '../../../constants/mainSearch.constants';

const { TabPane } = Tabs;

export const SearchFilters = ({ data, declinePostponeBlur, size }) => {
  const dispatch = useDispatch();
  const { scope = SEARCH_BAR_ALL, roadTypes } = data;
  const { tourIcon } = size;

  const changeHandler = (tab) => {
    dispatch(setFilterScope(tab));
  };

  const updateRoadTypes = (type) => {
    dispatch(setRoadTypesFilter(type));
  };

  const handleClick = () => declinePostponeBlur();

  const handleMouseDown = (e) => e.preventDefault();

  const { width, height } = size.mainIcon;

  const getTourTab = () => (
    <div className="main-search-filter-title">
      <ToursIconSearch width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="TOUR" defaultMessage="TOUR" />
      </span>
    </div>
  );

  const getBikeClubTab = () => (
    <div className="main-search-filter-title">
      <BikerClubIconSearch width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="BIKE CLUB" defaultMessage="BIKE CLUB" />
      </span>
    </div>
  );

  const getBikerBedTab = () => (
    <div className="main-search-filter-title">
      <BikerBedIconSearch width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="BIKERBED" defaultMessage="BIKERBED" />
      </span>
    </div>
  );

  const getPlaceTab = () => (
    <div className="main-search-filter-title">
      <PlacesSearchIcon width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="PLACES" defaultMessage="PLACES" />
      </span>
    </div>
  );

  const getMemberTab = () => (
    <div className="main-search-filter-title">
      <MemberSearchIcon width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="MEMBERS" defaultMessage="MEMBERS" />
      </span>
    </div>
  );

  const getAllTab = () => (
    <div className="main-search-filter-title">
      <AboutSearchIcon width={width} height={height} />
      <span className="sub_text">
        <FormattedMessage id="ALL" defaultMessage="ALL" />
      </span>
    </div>
  );

  return (
    <div
      className="main-search-filter-wrapper"
      onMouseDown={handleMouseDown}
      onClick={handleClick}
      aria-hidden
    >
      <Tabs
        defaultActiveKey={SEARCH_BAR_ALL}
        onChange={changeHandler}
        activeKey={scope}
      >
        <TabPane tab={getTourTab()} key={SEARCH_BAR_TOUR}>
          <TourTypesFilter
            type={roadTypes}
            updateType={updateRoadTypes}
            tourIcon={tourIcon}
          />
        </TabPane>

        <TabPane tab={getBikeClubTab()} key={SEARCH_BAR_BIKE_CLUB} />

        <TabPane tab={getBikerBedTab()} key={SEARCH_BAR_BIKER_BED} />

        <TabPane disabled tab={getPlaceTab()} key={SEARCH_BAR_PLACES} />

        <TabPane tab={getMemberTab()} key={SEARCH_BAR_MEMBER} />

        <TabPane tab={getAllTab()} key={SEARCH_BAR_ALL} />
      </Tabs>
    </div>
  );
};

SearchFilters.displayName = 'SearchFilters';
SearchFilters.propTypes = {
  data: PropTypes.object,
  declinePostponeBlur: PropTypes.func,
  size: PropTypes.object,
};
